// JSA RAC Info
export class JsaRacInfo {
  constructor(data = {}) {
    this.racAccessPotHazInfo = data.rac_access_pot_haz_info || "";
    this.racAccessElimHazInfo = data.rac_access_elim_haz_info || "";
    this.racAccessCode = data.rac_access_code || "";
    this.racChemicalPotHazInfo = data.rac_chemical_pot_haz_info || "";
    this.racChemicalElimHazInfo = data.rac_chemical_elim_haz_info || "";
    this.racChemicalCode = data.rac_chemical_code || "";
    this.racEnvironmentPotHazInfo = data.rac_environment_pot_haz_info || "";
    this.racEnvironmentElimHazInfo = data.rac_environment_elim_haz_info || "";
    this.racEnvironmentCode = data.rac_environment_code || "";
    this.racPhysicalPotHazInfo = data.rac_physical_pot_haz_info || "";
    this.racPhysicalElimHazInfo = data.rac_physical_elim_haz_info || "";
    this.racPhysicalCode = data.rac_physical_code || "";
    this.racPotEnergyPotHazInfo = data.rac_pot_energy_pot_haz_info || "";
    this.racPotEnergyElimHazInfo = data.rac_pot_energy_elim_haz_info || "";
    this.racPotEnergyCode = data.rac_pot_energy_code || "";
    this.racToolsPotHazInfo = data.rac_tools_pot_haz_info || "";
    this.racToolsElimHazInfo = data.rac_tools_elim_haz_info || "";
    this.racToolsCode = data.rac_tools_code || "";
    this.racOtherPotHazInfo = data.rac_other_pot_haz_info || "";
    this.racOtherElimHazInfo = data.rac_other_elim_haz_info || "";
    this.racOtherCode = data.rac_other_code || "";
  }

  updateJsaRacAccessPotHazInfo(data) {
    this.racAccessPotHazInfo = data;
  }

  updateJsaRacAccessElimHazInfo(data) {
    this.racAccessElimHazInfo = data;
  }

  updateJsaRacAccessCode(data) {
    this.racAccessCode = data;
  }

  updateJsaRacChemicalPotHazInfo(data) {
    this.racChemicalPotHazInfo = data;
  }

  updateJsaRacChemicalElimHazInfo(data) {
    this.racChemicalElimHazInfo = data;
  }

  updateJsaRacChemicalCode(data) {
    this.racChemicalCode = data;
  }

  updateJsaRacEnvironmentPotHazInfo(data) {
    this.racEnvironmentPotHazInfo = data;
  }

  updateJsaRacEnvironmentElimHazInfo(data) {
    this.racEnvironmentElimHazInfo = data;
  }

  updateJsaRacEnvironmentCode(data) {
    this.racEnvironmentCode = data;
  }

  updateJsaRacPhysicalPotHazInfo(data) {
    this.racPhysicalPotHazInfo = data;
  }

  updateJsaRacPhysicalElimHazInfo(data) {
    this.racPhysicalElimHazInfo = data;
  }

  updateJsaRacPhysicalCode(data) {
    this.racPhysicalCode = data;
  }

  updateJsaRacPotEnergyPotHazInfo(data) {
    this.racPotEnergyPotHazInfo = data;
  }

  updateJsaRacPotEnergyElimHazInfo(data) {
    this.racPotEnergyElimHazInfo = data;
  }

  updateJsaRacPotEnergyCode(data) {
    this.racPotEnergyCode = data;
  }

  updateJsaRacToolsPotHazInfo(data) {
    this.racToolsPotHazInfo = data;
  }

  updateJsaRacToolsElimHazInfo(data) {
    this.racToolsElimHazInfo = data;
  }

  updateJsaRacToolsCode(data) {
    this.racToolsCode = data;
  }

  updateJsaRacOtherPotHazInfo(data) {
    this.racOtherPotHazInfo = data;
  }

  updateJsaRacOtherElimHazInfo(data) {
    this.racOtherElimHazInfo = data;
  }

  updateJsaRacOtherCode(data) {
    this.racOtherCode = data;
  }

  // To json for sending to the database
  toJson() {
    return {
      rac_access_pot_haz_info: this.racAccessPotHazInfo,
      rac_access_elim_haz_info: this.racAccessElimHazInfo,
      rac_access_code: this.racAccessCode,
      rac_chemical_pot_haz_info: this.racChemicalPotHazInfo,
      rac_chemical_elim_haz_info: this.racChemicalElimHazInfo,
      rac_chemical_code: this.racChemicalCode,
      rac_environment_pot_haz_info: this.racEnvironmentPotHazInfo,
      rac_environment_elim_haz_info: this.racEnvironmentElimHazInfo,
      rac_environment_code: this.racEnvironmentCode,
      rac_physical_pot_haz_info: this.racPhysicalPotHazInfo,
      rac_physical_elim_haz_info: this.racPhysicalElimHazInfo,
      rac_physical_code: this.racPhysicalCode,
      rac_pot_energy_pot_haz_info: this.racPotEnergyPotHazInfo,
      rac_pot_energy_elim_haz_info: this.racPotEnergyElimHazInfo,
      rac_pot_energy_code: this.racPotEnergyCode,
      rac_tools_pot_haz_info: this.racToolsPotHazInfo,
      rac_tools_elim_haz_info: this.racToolsElimHazInfo,
      rac_tools_code: this.racToolsCode,
      rac_other_pot_haz_info: this.racOtherPotHazInfo,
      rac_other_elim_haz_info: this.racOtherElimHazInfo,
      rac_other_code: this.racOtherCode,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      // Keys match what actions pass (with jsa prefix)
      jsaRacAccessPotHazInfo: "rac_access_pot_haz_info",
      jsaRacAccessElimHazInfo: "rac_access_elim_haz_info",
      jsaRacAccessCode: "rac_access_code",
      jsaRacChemicalPotHazInfo: "rac_chemical_pot_haz_info",
      jsaRacChemicalElimHazInfo: "rac_chemical_elim_haz_info",
      jsaRacChemicalCode: "rac_chemical_code",
      jsaRacEnvironmentPotHazInfo: "rac_environment_pot_haz_info",
      jsaRacEnvironmentElimHazInfo: "rac_environment_elim_haz_info",
      jsaRacEnvironmentCode: "rac_environment_code",
      jsaRacPhysicalPotHazInfo: "rac_physical_pot_haz_info",
      jsaRacPhysicalElimHazInfo: "rac_physical_elim_haz_info",
      jsaRacPhysicalCode: "rac_physical_code",
      jsaRacPotEnergyPotHazInfo: "rac_pot_energy_pot_haz_info",
      jsaRacPotEnergyElimHazInfo: "rac_pot_energy_elim_haz_info",
      jsaRacPotEnergyCode: "rac_pot_energy_code",
      jsaRacToolsPotHazInfo: "rac_tools_pot_haz_info",
      jsaRacToolsElimHazInfo: "rac_tools_elim_haz_info",
      jsaRacToolsCode: "rac_tools_code",
      jsaRacOtherPotHazInfo: "rac_other_pot_haz_info",
      jsaRacOtherElimHazInfo: "rac_other_elim_haz_info",
      jsaRacOtherCode: "rac_other_code",
    };

    const patch = {
      patch_type: "jsa_rac_info",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
